import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updateItem from './../../../../API/Client/PutClientType'
import Loader from './../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import GetCountries from './../../../../API/Client/GetCountries'
import Select from 'react-select'
import { Col, Form, Row, Button } from 'react-bootstrap';

class UpdateTipKlijenta extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: false,

        countries: [],
        pickedCountry: null
    }

    componentDidMount = async () => {
        this.setState({ loading: true})
        //get countries
        let items = await GetCountries()       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })

        let pickedCountry = countryList.filter((data) => data.Form.Label === this.props.oneClientType.country)
        
            
        await this.setState({
            countries: countryList,
            pickedCountry: pickedCountry[0]
        })

        this.setState({ loading: false})
    }

    
    handleCountryChange(e){    
        this.setState({
            pickedCountry: e
        })                  
    }

    handleChange = async (e) => {
        await this.props.mapState("CHANGE_ONE_CLIENT_TYPE_DETAILS", e.target) 
    }

    submitUpdate = async (e) =>{
        const { t } = this.props

        e.preventDefault()
        let updatePP = await updateItem(this.props.oneClientType, this.state.pickedCountry.value)
        if(updatePP.data.status === 200){
            store.addNotification({
                title: t('Success!'),
                message: t('The Client type has been changed'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
        else(
            store.addNotification({
                title: t('Error!'),
                message: t("An error occurred while changing the client type, please try again."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        this.props.goBack()
    }

    render(){  
        const { t } = this.props
        return (
            this.state.loading ?
                <Loader />
            :
                <Form className="form-container">
                    <Row>          
                        <Col sm={12} lg={6} xl={4}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm={2} md={4} htmlFor="client_type">{t('Name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control      
                                        id="client_type"                          
                                        type="text"
                                        value={this.props.oneClientType.client_type}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm={2} md={4} htmlFor="country">{t('Country')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Select
                                        options={this.state.countries} 
                                        onChange={(values) => this.handleCountryChange(values)}
                                        isClearable
                                        isInvalid={this.state.pickedCountry === null}
                                        value={this.state.pickedCountry}

                                    />                                  
                                </Col>
                            </Form.Group>
   
                            <div className="mb-3 text-center">
                                <Button                                     
                                    className="btnSpremi"                                     
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </div>                                  
                        </Col> 
                    </Row>           
                    
                    <Row className="back-button-container">
                        <Button 
                            variant='default'
                            className="btn-default mt-2 mb-2"
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        
                        </Button>
                    </Row>
                </Form>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientType: state.codeBook.oneClientType
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdateTipKlijenta));


